export default [
    {
        name:"bots",
        type: "glbModel",
        path: "/models/bots.glb"
    },
    /*{
        name:"screen",
        type: "videoTexture",
        path: "/textures/demo.gif"
    }*/
]